<template>
  <div class="container-fluid container-with-vertical-nav full-height cards-pf">
    <div class="row row-cards-pf">
      <div class="col-xs-12">
        <div class="card-pf">
          <div class="card-pf-heading">
            <h2 class="card-pf-title">แก้ไขหน่วยงาน</h2>
          </div>
          <div class="card-pf-body">
            <form action="/" class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label required-field">ชื่อหน่วยงาน</label>
                <div class="col-sm-8">
                  <input v-model="group.name" type="text" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label required-field">สังกัต</label>
                <div class="col-sm-8">
                  <input v-model="group.department" type="text" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label required-field">ประเภท</label>
                <div class="col-sm-8">
                  <select v-model="group.type" class="selectpicker">
                    <option>ชุมนุม</option>
                    <option>ชมรม</option>
                    <option>สโมสร</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label required-field">ประธาน</label>
                <div class="col-sm-8">
                  <input v-model="group.cheifName" type="text" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-8 col-sm-offset-3">
                  <button class="btn btn-primary" @click.prevent="submit">บันทึก</button>
                  <router-link :to="{ name: 'settings.groups.show', params: { id: $route.params.id } }" class="btn btn-default">ยกเลิก</router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  apollo: {
    group: {
      query: gql`query group($id: ID!){
        group(_id: $id) {
          name
          department
          type
          cheifName
          advisorName
          advisor {
            firstName
            lastName
          }
        }
      }`,
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  data () {
    return {
      group: {
        name: '',
        type: '',
        department: '',
        cheifName: '',
        advisorName: '',
        advisor: {
          firstName: '',
          lastName: ''
        }
      }
    }
  },
  methods: {
    async submit () {
      const group = await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $group: EditGroupInput!) {
          updateGroup(_id: $id ,group: $group) {
            _id
          }
        }`,
        variables: {
          group: {
            name: this.group.name,
            department: this.group.department,
            type: this.group.type,
            cheifName: this.group.cheifName,
            advisorName: this.group.advisorName
          },
          id: this.$route.params.id
        }
      })

      // TODO: Implement toast notification

      this.$router.push({ name: 'settings.groups.show', params: { id: group.data.updateGroup._id } })
    }
  }
}
</script>

<style lang="sass" scoped>
//
</style>



// WEBPACK FOOTER //
// src/js/views/settings/groups/Edit.vue